/**
 * Constantes pour les types de désactivation côté frontend
 * Doit rester synchronisé avec backend/constants/listingReasons.js
 */

// Types de désactivation
export const DEACTIVATION_TYPES = {
  TEMPORARY: 'temporary',
  PERMANENT: 'permanent'
};

// Labels pour l'interface utilisateur
export const DEACTIVATION_LABELS = {
  [DEACTIVATION_TYPES.TEMPORARY]: {
    short: 'Temporaire',
    full: 'Désactivation temporaire (permet la resoumission)',
    icon: '🔄',
    description: 'ℹ️ L\'utilisateur pourra corriger et resoumettre l\'annonce',
    color: 'warning'
  },
  [DEACTIVATION_TYPES.PERMANENT]: {
    short: 'Permanente',
    full: 'Désactivation permanente (bloque les modifications)',
    icon: '🚫',
    description: '⚠️ ATTENTION : L\'utilisateur ne pourra plus modifier cette annonce',
    color: 'error'
  }
};

// Motifs prédéfinis par type de désactivation
export const PREDEFINED_DEACTIVATION_REASONS = {
  [DEACTIVATION_TYPES.TEMPORARY]: [
    "Informations manquantes ou incomplètes",
    "Images de mauvaise qualité",
    "Description inappropriée ou trompeuse",
    "Problème de tarification",
    "Catégorie incorrecte",
    "Documents manquants",
    "Vérification technique requise",
    "Modération du contenu nécessaire",
    "Vérification d'adresse requise",
    "Vérification du propriétaire en cours"
  ],
  [DEACTIVATION_TYPES.PERMANENT]: [
    "Activité frauduleuse détectée",
    "Problème légal en cours",
    "Violations répétées des conditions d'utilisation",
    "Menace pour la sécurité de la plateforme",
    "Utilisateur banni de la plateforme",
    "Contenu illégal ou dangereux",
    "Violation de droits d'auteur",
    "Décision administrative définitive"
  ]
};

// Validation des types
export const isValidDeactivationType = (type) => {
  return Object.values(DEACTIVATION_TYPES).includes(type);
};

// Récupération des motifs par type
export const getDeactivationReasons = (type) => {
  if (!isValidDeactivationType(type)) {
    console.warn(`Type de désactivation invalide: ${type}`);
    return PREDEFINED_DEACTIVATION_REASONS[DEACTIVATION_TYPES.TEMPORARY];
  }
  return PREDEFINED_DEACTIVATION_REASONS[type];
};

// Récupération des labels par type
export const getDeactivationLabel = (type, format = 'full') => {
  if (!isValidDeactivationType(type)) {
    console.warn(`Type de désactivation invalide: ${type}`);
    return DEACTIVATION_LABELS[DEACTIVATION_TYPES.TEMPORARY][format];
  }
  return DEACTIVATION_LABELS[type][format];
};